// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
require('../internals/define-well-known-symbol')('patternMatch');